import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import dayjs from 'dayjs';
import {
  Box,
  Paper,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { listChanceEstimates } from '../../../modules/chanceModule/chanceEstimates';

import CostCalcListContainer from '../../../containers/chancemng/estimate/CostCalcListContainer';
import DetailTemplate from '../../common/template/DetailTemplate';
import EstimateFormContainer from '../../../containers/chancemng/estimate/EstimateFormContainer';
import PurchseQuoteFileListContainer from '../../../containers/chancemng/estimate/PurchseQuoteFileListContainer';
import _ from 'lodash';
import * as chanceApi from '../../../lib/api/chance';
import * as fileApi from '../../../lib/api/file';
import { listPurchaseQuoteFiles } from '../../../modules/chanceModule/purchaseQuoteFiles';
import EstimatePreviewModal from './EstimatePreviewModal';
import Draggable from 'react-draggable';
import { chanceEstimateActive } from '../../../modules/chanceModule/chance';
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-estimate-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const EstimateModal = ({
  chance,
  type,
  estimate,
  open,
  handleClose,
  orderCount,
  vendorEmps,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [showPreview, setShowPreview] = useState(false);
  const [title, setTitle] = useState('세부사항');

  //파일명 확인
  const downloadFile = (file, filename, filedoc) => {
    let blob = new Blob([file.data]);
    let fileName = `${filename}.${filedoc}`;

    if (window.navigator.msSaveOrOpenBlob) {
      // IE 10+는 해당 함수 제공
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.target = '_self';
      if (fileName) link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
  };

  const closePreview = () => {
    setShowPreview(false);
  };

  const handlePreview = () => {
    setShowPreview(true);
    // console.log(formik.values, 'values');
  };

  const handleExcel = async () => {
    try {
      const blob = await chanceApi.downloadExcel(estimate.qteUuid);
      const filename = blob.headers['filename'];

      downloadFile(blob, decodeURIComponent(filename), 'xlsx');
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };


  const validationSchema = yup.object({
    qteRegDt: yup
      .date()
      .required('견적일자를 입력하세요')
      .nullable()
      .default(undefined),
    qteValidDt: yup
      .date()
      .required('견적유효일을 입력하세요')
      .nullable()
      .default(undefined),
    mntTor: yup.number('숫자만 가능합니다'),
    destPlace: yup.string().required('납품 장소를 입력하세요'),
    qteCondt: yup.string().required('발행 조건을 입력하세요'),
    payCond: yup.string().required('결제 조건을 입력하세요'),
    qteDesc1: yup.string().required('견적서 설명 1을 입력하세요'),
    qteUsrNm: yup.string().required('담당자명을 입력하세요'),
    qteUsrTel: yup.string().required('담당자 연락처를 입력하세요'),
    qteUsrEml: yup
      .string()
      .email('잘못된 이메일 형식입니다')
      .required('담당자 이메일을 입력하세요'),
  });

  const [initialValues, setInitialValues] = useState({
    qtePrice:
      estimate && estimate?.qtePrice !== undefined
        ? estimate?.qtePrice
        : chance?.expSales,
    qteRegDt:
      estimate !== null
        ? estimate?.qteRegDt
          ? estimate?.qteRegDt
          : estimate?.crtDt
        : new Date(),
    qteValidDt: dayjs().add(30, 'day').format('YYYY-MM-DD'),
    mntTor: 12,
    destPlace: '고객이 지정한 장소',
    qteCondt: '검수후 발행',
    payCond: '현금',
    qteDesc1:
      '해당 견적서의 직인은 생략하며, 직인 필요시 별도 문의 부탁 드립니다.',
    qteDesc2: '',
    qteDesc3: '',
    qteUsrNm: '',
    qteUsrTel: '',
    qteUsrEml: '',
    crtDt: new Date(),
    files: [{ fileDesc: '', file: null }],
  });

  useEffect(() => {
    if (estimate) {
      const detailTitle = '견적서 번호: ' + estimate?.qteNo + ' 상세 사항';
      setTitle(detailTitle);

      const copyEstimate = _.clone(estimate);
      const qteRegDt =
        estimate !== null
          ? estimate?.qteRegDt
            ? estimate?.qteRegDt
            : estimate?.crtDt
          : new Date();

      const init = {
        ...copyEstimate,
        qteRegDt,
        files: [{ fileDesc: '', file: null }],
      };
      setInitialValues(init);
    }
  }, [estimate, type]);

  useEffect(() => {
    if (type === 'add' && vendorEmps && vendorEmps.length > 0) {
      const qteUsrNm = vendorEmps[0]?.employeeNm;
      const qteUsrTel = vendorEmps[0]?.telNo;
      const qteUsrEml = vendorEmps[0]?.emailAddr;
      const copyInit = _.clone(initialValues);
      const changeInit = { ...copyInit, qteUsrNm, qteUsrTel, qteUsrEml };
      setInitialValues(changeInit);
    }
  }, [type, vendorEmps]);

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
      handleClose();
    },
  });

  const onFileSave = async (value, estimate) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'project');
    formData.append('fileAttrVal1', estimate.prjUuid);
    formData.append('fileAttrVal2', '매입견적서');
    formData.append('fileAttrVal3', estimate.qteUuid);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar('매입견적서 업로드 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  // 1. 공통 데이터 갱신 함수 (모달 내부 혹은 외부에 선언)
  const refreshData = (prjUuid) => {
    dispatch(listChanceEstimates(prjUuid));    // 리스트 갱신
    dispatch(chanceEstimateActive(prjUuid));   // 활성화 상태 갱신
  };

  const onSave = async (values) => {
    const prjUuid = chance.prjUuid;
    let estimateToSubmit = {
      prjUuid,
      qteTyp: chance?.prjTyp === 'M' ? 'B' : 'A',
      qteKind: 'S',
      qtePrice: values.qtePrice,
      qteRegDt: dayjs(values.qteRegDt).format('YYYY-MM-DD'),
      qteValidDt: values.qteValidDt ? dayjs(values.qteValidDt).format('YYYY-MM-DD') : dayjs().add(30, 'day').format('YYYY-MM-DD'),
      mntTor: values.mntTor,
      destPlace: values.destPlace,
      payCond: values.payCond,
      qteCondt: values.qteCondt,
      qteDesc1: values.qteDesc1,
      qteDesc2: values.qteDesc2,
      qteDesc3: values.qteDesc3,
      qteUsrNm: values.qteUsrNm,
      qteUsrTel: values.qteUsrTel,
      qteUsrEml: values.qteUsrEml,
    };

    try {
      let res;
      if (type === 'add') {
        res = await chanceApi.addEstimate(estimateToSubmit);
        const newInfo = res.data;
        if (newInfo) {
          // 파일 저장 (기존 로직)
          if (values.files?.length > 0 && values.files[0].file !== null) {
            values.files.forEach((file) => onFileSave(file, newInfo));
          }
          enqueueSnackbar('견적 등록 성공', { variant: 'success' });
        }
      } else {
        estimateToSubmit.qteUuid = estimate.qteUuid;
        res = await chanceApi.editEstimate(estimateToSubmit);
        const editInfo = res.data.info;
        if (editInfo) {
          // 파일 저장 및 갱신
          if (values.files?.length > 0 && values.files[0].file !== null) {
            values.files.forEach((file) => {
              onFileSave(file, editInfo);
              dispatch(listPurchaseQuoteFiles('project', editInfo.prjUuid, editInfo.qteUuid));
            });
          }
          enqueueSnackbar('견적 수정 성공', { variant: 'success' });
        }
      }
      
      // ✅ 등록/수정 공통: 데이터 최신화 호출
      refreshData(prjUuid);
      handleClose(); // 성공 시 모달 닫기 추가

    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  const handleDelete = async () => {
    const { prjUuid, qteUuid } = estimate;
    try {
      const res = await chanceApi.removeEstimate(prjUuid, qteUuid);
      if (res.data) {
        // ✅ 삭제 성공 후 데이터 최신화
        refreshData(prjUuid);
      }
      enqueueSnackbar('견적 삭제 성공', { variant: 'success' });
      handleClose();
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    }
  };


  if (!chance) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-estimate-dialog"
      fullWidth={true}
      maxWidth="xl"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-estimate-dialog"
        onClose={handleClose}
      >
        견적서 - [{chance?.prjNo}]{chance?.cstNm}
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent
          dividers
          sx={{
            height: 800,
            overflowY: 'auto',
          }}
        >
          <DetailTemplate title={title}>
            <EstimateFormContainer
              formik={formik}
              type={type}
              chance={chance}
              estimate={estimate}
              handleClose={handleClose}
            />
          </DetailTemplate>

          {type === 'edit' && (
            <DetailTemplate title="매입견적서 리스트">
              <PurchseQuoteFileListContainer estimate={estimate} />
            </DetailTemplate>
          )}

          <DetailTemplate title="원가 산출 리스트">
            <CostCalcListContainer />
          </DetailTemplate>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <>
            <Box>
              {orderCount === 0 ? (
                <Button
                  color="error"
                  variant="contained"
                  onClick={handleDelete}
                >
                  삭제
                </Button>
              ) : (
                <Typography variant="subtitle2" color="error.main">
                  현재 Active한 수주품의서가 있어, 견적서 삭제 불가합니다.
                </Typography>
              )}
            </Box>
            {type === 'edit' && estimate?.useYn === 'Y' && (
              <Box>
                <Button
                  sx={{ mr: 2 }}
                  color="info"
                  variant="contained"
                  onClick={handlePreview}
                >
                  미리보기
                </Button>

                <Button
                  sx={{ mr: 2 }}
                  color="secondary"
                  variant="contained"
                  onClick={handleExcel}
                >
                  엑셀
                </Button>
              </Box>
            )}
          </>
          {type === 'add' && (
            <Box>
              <Button
                sx={{ mr: 2 }}
                color="info"
                variant="contained"
                onClick={handlePreview}
              >
                미리보기
              </Button>
            </Box>
          )}
        </DialogActions>
      </Box>
      {showPreview && (
        <EstimatePreviewModal
          type={type}
          chance={chance}
          estimate={formik.values}
          open={showPreview}
          handleClose={closePreview}
        />
      )}
    </BootstrapDialog>
  );
};

export default EstimateModal;
